var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height"},[_c('app-topbar'),_c('b-row',[_c('b-col',{staticClass:"ct-side-bar",attrs:{"cols":"4","md":"2"}},[_c('app-sidebar')],1),_c('b-col',{staticClass:"router-view",attrs:{"cols":"8","md":"10"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }